'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/CurrencyCircleDollar.js";
var m = Object.defineProperty, i = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var t = (e, r, o) => r in e ? m(e, r, { enumerable: true, configurable: true, writable: true, value: o }) : e[r] = o, c = (e, r) => {
  for (var o in r || (r = {}))
    n.call(r, o) && t(e, o, r[o]);
  if (a)
    for (var o of a(r))
      p.call(r, o) && t(e, o, r[o]);
  return e;
}, l = (e, r) => i(e, f(r));
const u = forwardRef((e, r) => /* @__PURE__ */ a__default.createElement(b, l(c({ ref: r }, e), { weights: t$1 })));
u.displayName = "CurrencyCircleDollar";
export {
  u as CurrencyCircleDollar
};
